/* eslint-disable react-hooks/exhaustive-deps */
import { SharedThing } from '@eagle/core-data-types';
import { Skeleton, Typography } from '@ethings/ui-toolkit';
import { Box } from '@mui/system';
import { FC } from 'react';
import { useAuthenticated } from '../../auth';
import { usePromise } from '../../hooks';
import { ListPaperColumn } from '../list-item';

interface Props {
  sharedThing: SharedThing;
  stakeholder: string;
  label?: string;
  wrap?: boolean;
}

export const StakeholderColumn: FC<Props> = ({ sharedThing, stakeholder, label, wrap = true }) => {
  const { restClient } = useAuthenticated();
  const stakeholderId = sharedThing.lifecycleState?.stakeholders?.[stakeholder];
  const columnLabel = label || stakeholder;

  const [account, accountError, accountState] = usePromise(
    async () => {
      if (!stakeholderId) return;
      return restClient.sharedThing.getStakeholderAccount(sharedThing._id, stakeholder, stakeholderId);
    },
    [restClient, stakeholderId],
  );

  const displayText = account?.display ?? '';

  if (!stakeholderId || accountError) {
    return <Box />;
  }

  return <ListPaperColumn
    data-testid={`transfers-list-column-${stakeholder}`}
    label={columnLabel}
    wrap={wrap}
    sx={{
      overflow: 'visible',
      '& > label': {
        textTransform: 'capitalize',
      },
      '& > div': {
        whiteSpace: 'normal',
        overflow: 'visible',
        textOverflow: 'clip',
        width: '100%',
        wordBreak: 'break-word',
      },
      minWidth: '150px',
      maxWidth: '250px',
      '@media (max-width: 600px)': {
        minWidth: 0,
        maxWidth: 'none',
        '& .MuiTypography-root': {
          fontSize: '0.875rem',
          minHeight: '1.25em',
        },
      },
    }}>
    {accountState === 'pending'
      ? <Skeleton variant="text" style={{ width: '25%', height: 24 }} />
      : <Typography
        style={{
          wordBreak: 'break-word',
          whiteSpace: 'normal',
          overflow: 'visible',
        }}
        title={displayText}
      >
        {displayText}
      </Typography>
    }
  </ListPaperColumn>;
};
